import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-vs-railway',
  imports: [RouterLink, MatButtonModule, MatIconModule],
  templateUrl: './railway.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../vs.shared.css', './railway.component.css'],
})
export class VsRailwayComponent {}
